import React from 'react'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function OptionsLabel(props) {
  const {preferences} = props
  const {t} = useTranslation('website', {keyPrefix: 'order.cartMenuV2.optionsLabel'})

  if (!preferences.cart) return <div className={styles.loading}></div>

  if (preferences.deliveryType === 'delivery') {
    if (preferences.address) {
      return <div className={styles.container}>{preferences.address.address}</div>
    } else {
      return <div className={styles.container}>{t('address')}</div>
    }
  }

  if (!preferences.store) {
    return <div className={styles.container}>{t('store')}</div>
  }

  if (preferences.deliveryType === 'go') {
    return <div className={styles.container}>{t('storeGo', {store: preferences.store.name})}</div>
  }

  const label = preferences.tableName
    ? t('labelTable', {table: preferences.tableName})
    : t('labelServe')

  return (
    <div className={styles.container}>
      {preferences.store.name}, {label}
    </div>
  )
}
